import React, { Component, ReactNode, createRef, RefObject } from "react";
import styles from "./styles.module.sass";

interface FaqItemProps {
  children?: ReactNode;
  question?: ReactNode;
}

interface FaqItemState {
  height: number | null;
  isOpen: boolean;
}

class FaqItem extends Component<FaqItemProps, FaqItemState> {
  private answerRef: RefObject<HTMLDivElement | null>;

  constructor(props: FaqItemProps) {
    super(props);
    this.state = {
      height: null,
      isOpen: true,
    };
    this.answerRef = createRef<HTMLDivElement>();
  }

  componentDidMount() {
    this.updateHeight();
  }

  updateHeight() {
    if (this.answerRef.current) {
      this.setState({
        height: this.answerRef.current.clientHeight,
        isOpen: false,
      });
    }
  }

  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    const { height, isOpen } = this.state;
    const { question, children } = this.props;

    return (
      <div className={styles.item}>
        <div className={styles.question} onClick={this.toggle}>
          {question}
        </div>
        <div
          className={styles.answerWrapper}
          style={{ height: isOpen ? height ?? undefined : 0 }}
          ref={this.answerRef}
        >
          <div className={styles.answer}>{children}</div>
        </div>
      </div>
    );
  }
}

export default FaqItem;
